<template>
    <div>
        <div :id="reactContainerId"></div>
    </div>
</template>

<script>
import { mountReactComponent, unmountReactComponent } from "../../../../utility/mountReactComponent";
import AddUser from "../../../react-view/AddUser";

export default {
    name: "CreateACUReactWrapper",
    props: {
        acuModels: {
            type: Object,
        },
        closeACUModal: {
            type: Function,
        },
        showNotification: {
            type: Function,
        },
    },
    data() {
        return {
            reactContainerId: `react-container-${Math.random().toString(36).substr(2, 9)}`, // Unique ID
        };
    },
    methods: {
        mountReactComponent() {
            mountReactComponent(
                AddUser,
                {
                    closeACUModal: this.closeACUModal,
                    acuModels: this.acuModels,
                    showNotification: this.showNotification,
                },
                this.reactContainerId
            );
        },
        unmountReactComponent() {
            unmountReactComponent(this.reactContainerId); // Clean up the React component
        },
    },
    mounted() {
        if (this.acuModels) {

            this.mountReactComponent();
        }
    },
    beforeDestroy() {
        this.unmountReactComponent();
    },
    watch: {
        acuModels: {
            deep: true, // Watches for deep changes in the object
            handler() {
                this.unmountReactComponent(); // Clean up the previous React component
                this.mountReactComponent(); // Mount with updated data
            },
        },
    },
};
</script>
